import CSS from "./static/css/AddressInfoCard.module.css";
import MainInfoCard from "../../../../Component/Elements/MainInfoCard/MainInfoCard";
import AddressInfoMain from "../AddressInfoMain/AddressInfoMain";
import { ProductDetail_SelectInformationDate_Address_Interface } from "../../static/interface/ProductDetail.interface";
import { Dispatch, SetStateAction } from "react";

const AddressInfoCard = (
    {
        addressList,
        setAddressList,
        productQty,
        totalAddressQty
    }:{
        addressList: ProductDetail_SelectInformationDate_Address_Interface[];
        setAddressList: Dispatch<SetStateAction<ProductDetail_SelectInformationDate_Address_Interface[]>>;
        productQty: number;
        totalAddressQty: number;
    }
) => {

    return(
        <div className={CSS.l_AddressInfoCard_main}>
            {
                addressList.map((item, index) => {
                    return(
                        <MainInfoCard key={index}>
                            <AddressInfoMain
                                address_index={index}
                                view_mode={"edit"}
                                product_qty={productQty}
                                total_address_qty={totalAddressQty}
                                address_qty={item.product_qty}
                                addressList={addressList}
                                setAddressList={setAddressList}
                            />
                        </MainInfoCard>
                    )
                })
            }
        </div>
    )
}

export default AddressInfoCard;